import script from "./section4.vue?vue&type=script&setup=true&lang=js"
export * from "./section4.vue?vue&type=script&setup=true&lang=js"

import "./section4.vue?vue&type=style&index=0&id=03af984b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03af984b"]])

export default __exports__